'use strict';

(() => {
  if (customElements.get('marquee-text')) return;

  class MarqueeText extends HTMLElement {
    constructor() {
      super();
      this.availableColors = [];
      this.previousColorIndex = -1;
      this.applyRandomColors = this.applyRandomColors.bind(this);
    }

    connectedCallback() {
      this.loadAvailableColors();
      this.addEventListener('mouseenter', this.applyRandomColors);

      const durationMap = {
        slow: '80s',
        normal: '55s',
        fast: '40s',
        'very-fast': '26s',
        'ultra-fast': '18s',
      };
      const speed = this.dataset.speed || 'fast';
      this.style.setProperty('--_animation-duration', durationMap[speed] || durationMap.fast);
      this.dataset.animated = 'true';
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.applyRandomColors);
    }

    loadAvailableColors() {
      this.availableColors = [];
      for (let index = 1; index <= 4; index += 1) {
        const background = this.getAttribute(`data-bg-${index}`);
        const text = this.getAttribute(`data-text-${index}`);
        if (background && text) this.availableColors.push({ background, text });
      }
    }

    applyRandomColors() {
      if (!this.availableColors.length || !this.parentElement) return;

      let nextIndex = 0;
      if (this.availableColors.length > 1) {
        do {
          nextIndex = Math.floor(Math.random() * this.availableColors.length);
        } while (nextIndex === this.previousColorIndex);
      }

      this.previousColorIndex = nextIndex;
      const color = this.availableColors[nextIndex];
      this.parentElement.style.setProperty('--color-background-h', color.background);
      this.parentElement.style.setProperty('--color-foreground-h', color.text);
    }
  }

  customElements.define('marquee-text', MarqueeText);
})();
